<template>
    <div class="empty-outer" :style="`height: ${height}`">
        <div class="empty-inner">
            <svg class="empty">
                <use :xlink:href="require('@/assets/img/icons/alert-circle.svg')+'#layer'"></use>
            </svg>
            <div class="empty-text">
                {{ msg != '' ? $t(msg) : '' }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        msg: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: 'calc(100vh - 360px)'
        }
    }
}
</script>

<style lang="scss" scoped>
.empty-outer {
    display: flex;
    align-items: center;
    justify-content: center;

    .empty-inner {
        text-align: center;

        .empty {
            fill: #898989;
            width: 50px !important;
            height: 50px !important;
        }

        .empty-text {
            font-weight: 600;
        }
    }

}
</style>

